import { money } from "./quotePricingPolicy";

export function buildModifiedQuotePayload({ payload, includedPartIds, pricedById, partVat, deliveryPerPart, partOldExchange, deliveryEnabled, deliveryAmount, messageText }) {
    const parts = (payload.parts ?? []).map(p => {
      const isIncluded = includedPartIds.has(p.query_part_id);
      const calculated = pricedById.get(Number(p.query_part_id));
      const sp = calculated.sp;
      const { pct = 5, mode = "excl" } = partVat[p.query_part_id] ?? {};
      const share = isIncluded ? deliveryPerPart : 0;
      const finalPrice = money(mode === "incl" ? (sp + share) * (1 + pct / 100) : (sp + share));
      return {
        ...p,
        included: isIncluded,
        sp,
        base_sp: calculated.base_sp,
        cp: calculated.cp,
        vat_pct: pct,
        vat_enabled: mode !== "none", // kept for older readers of this payload shape
        vat_mode: mode,
        delivery_share: isIncluded ? Number(deliveryPerPart.toFixed(2)) : 0,
        final_price: finalPrice,
        old_exchange: partOldExchange[p.query_part_id] ?? !!p.old_exchange,
      };
    });
    return {
      ...payload,
      pricing_policy_version: 2,
      delivery_enabled: deliveryEnabled,
      delivery_amount: deliveryEnabled ? deliveryAmount ?? 0 : 0,
      message_text: messageText.trim(),
      parts,
    };

}
